import type {ReactElement} from 'react';
import React from 'react';
import type {AiGeneratedContent} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';
import {AiPromptBoxVariant} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';
import {ClickableDiv} from '@Components/clickable-div';
import {isMultiContentAiGeneration, isRecentAiGeneration} from '@Libraries/ai-text-prompt-box-library';
import styles from './ai-text-list-item.module.scss';

interface AiTextListItemProps {
  previousCaptionsSeparatorMarkup: React.ReactElement | null;
  areNewCaptionsLoading: boolean;
  content: AiGeneratedContent;
  index: number;
  onClick: (caption: AiGeneratedContent) => void;
  variant: AiPromptBoxVariant;
}

export function AiTextListItem({...props}: AiTextListItemProps): ReactElement {
  const getSubtextIfExists = (): ReactElement | null => {
    if (props.variant === AiPromptBoxVariant.MONOCONTENT) {
      return null;
    }

    if (!isMultiContentAiGeneration(props.content)) {
      return null;
    }

    return <div className={styles.aiTextsListItemSubText}>{props.content.subtext}</div>;
  };

  return (
    <li className={`${styles.aiTextsListItem} spacing-m-b-5 ${isMultiContentAiGeneration(props.content) ? styles.recentCaption : ''}`}>
      {props.previousCaptionsSeparatorMarkup}
      <ClickableDiv
        className={`flex-row-align-center ${styles.aiTextsListItemClickable} ${props.areNewCaptionsLoading ? styles.disabled : ''}`}
        id={isRecentAiGeneration(props.content) ? props.content.id : props.content.text.trim()}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          props.onClick(props.content);
        }}
      >
        <div className="flex-align-center flex-row flexbox">
          <div className={styles.aiTextsListItemIndex}>{props.index + 1}.</div>
          <div>
            <div className={styles.aiTextsListItemText}>{props.content.text}</div>
            {getSubtextIfExists()}
          </div>
        </div>
      </ClickableDiv>
    </li>
  );
}
